export var lockBusinessManage = {
  name: "锁车业务管理",
  path: "/lock-business-manage",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "8",
  sort: 3,
  alwaysShow: true,
  meta: {
    title: "锁车业务管理",
    icon: "lock",
    noCache: false
  },
  children: [{
    name: "LockBusinessManage",
    path: "/lock-business-manage/index",
    hidden: false,
    component: "lockBusinessManage/index",
    elemCode: "9",
    meta: {
      title: "锁车业务管理",
      noCache: true
    }
  }]
};